import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export const DEPLOYMENT_DOMAIN = process.env.DEPLOYMENT_DOMAIN;
export const ENABLE_IFSC_PAGES = process.env.ENABLE_IFSC_PAGES;
export const ENABLE_WEBINAR_PAGES = process.env.ENABLE_WEBINAR_PAGES;
export const API_AUTH_TOKEN = publicRuntimeConfig?.API_AUTH_TOKEN;
